/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Direct_Jpgpngwebp_UrlInputs */

const en_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste direct JPG/PNG/WebP URL...`)
};

const es_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega URL directa de JPG/PNG/WebP...`)
};

const fr_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez l'URL directe JPG/PNG/WebP...`)
};

const de_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge eine direkte JPG/PNG/WebP-URL ein...`)
};

const ja_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPG/PNG/WebPの直接URLを貼り付け...`)
};

const zh_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴直接的 JPG/PNG/WebP 链接...`)
};

const ar_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصق رابطاً مباشراً لـ JPG/PNG/WebP...`)
};

const id_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel URL langsung JPG/PNG/WebP...`)
};

const it_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla l'URL diretto JPG/PNG/WebP...`)
};

const ru_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставьте прямую ссылку на JPG/PNG/WebP...`)
};

const pt_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole URL direta de JPG/PNG/WebP...`)
};

const ko_paste_direct_jpgpngwebp_url = /** @type {(inputs: Paste_Direct_Jpgpngwebp_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JPG/PNG/WebP 직접 URL을 붙여넣으세요...`)
};

/**
* | output |
* | --- |
* | "Paste direct JPG/PNG/WebP URL..." |
*
* @param {Paste_Direct_Jpgpngwebp_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const paste_direct_jpgpngwebp_url = /** @type {((inputs?: Paste_Direct_Jpgpngwebp_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Direct_Jpgpngwebp_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "es") return es_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "fr") return fr_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "de") return de_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "ja") return ja_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "zh") return zh_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "ar") return ar_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "id") return id_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "it") return it_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "ru") return ru_paste_direct_jpgpngwebp_url(inputs)
	if (locale === "pt") return pt_paste_direct_jpgpngwebp_url(inputs)
	return ko_paste_direct_jpgpngwebp_url(inputs)
});